import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RadioControlValueAccessor, FormGroup, FormArray, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { MetadataService, ApiService, AdminService, TranslatorService, FormulaService } from '../../services';
import { Field, HeaderField, SeparatorField, DropdownField, RadioListField, MultiSelectField, FileField, Separator1Field, MultiSelectListField } from '../../models';

@Component({
    selector: 'sn-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.css']
})
export class FieldComponent implements OnInit {
    @Input() field: any;
    @Input() form: FormGroup;
    @Input() view: any;
    @Input() data: any;
    @Input() conditions: any;
    @Input() formulas: any;
    @Input() public processListItems: Function;
    @Input() public openUserLookupEvent: Function;
    @Input() public getErrorMessageCallback: Function;
    @Input() public openCustomInputEvent: Function;
    @Input() public getCurrentFormValuesEvent: Function;
    @Input() public formValueOnChangeBehavior: Observable<any>;
    @Output() public valueChange = new EventEmitter();

    subfix_colon: string = ": ";
    isFileUploading: boolean = false;
    listItems: Array<any> = [];
    current_json_data: string;
    current_formula_results: any[];

    constructor(
        private metadataService: MetadataService,
        private apiService: ApiService,
        private adminService: AdminService,
        private ngbModal: NgbModal,
        private translatorService: TranslatorService,
        private formulaService: FormulaService,
    ) { }

    ngOnInit() {
        //this.current_json_data = JSON.stringify(this.data);
        if (this.field) {
            switch (this.field.display_type) {
                case "UR":
                    if (this.form.value["u_firstname"]) this.selectedUser = this.form.value["u_firstname"] + ' ';
                    if (this.form.value["u_lastname"]) this.selectedUser += this.form.value["u_lastname"];
                    break;
                case DropdownField.control_type:
                case RadioListField.control_type:
                case MultiSelectField.control_type:
                case MultiSelectListField.control_type:
                    this.loadListItems();
                    break;
            }

            if (this.formValueOnChangeBehavior) {
                this.formValueOnChangeBehavior.subscribe(value => {
                    if (value && value.child_controls && value.child_controls.indexOf(this.field.key) >= 0) {
                        switch (this.field.display_type) {
                            case DropdownField.control_type:
                            case RadioListField.control_type:
                            case MultiSelectField.control_type:
                            case MultiSelectListField.control_type:
                                this.loadListItems();
                                break;
                        }
                    }
                });
            }
        }
    }

    loadListItems() {
        let fm = this.metadataService.getField(this.field.sn_ID);
        if (fm) {
            this.listItems = fm.list_items;
            if (this.processListItems) this.listItems = this.processListItems(this.view, this.data, this.field, fm);
        }
    }

    getErrorMsg(field) {
        var msg = (this.getErrorMessageCallback) ? this.getErrorMessageCallback(field) : "";
        return msg;
    }

    onChange(e, listItem) {
        if (this.field.display_type == MultiSelectField.control_type) {
            if (this.field.value == undefined || this.field.value == null) this.field.value = [];
            var index = this.field.value.indexOf(listItem.value);
            if (index >= 0) {
                this.field.value.splice(index, 1);
            } else {
                this.field.value.push(listItem.value);
            }
        } else if (this.field.display_type == MultiSelectListField.control_type) {
            var value = document["jQuery"](e.currentTarget).val();
            this.field.value = value != null ? value : [];
        } else {
            this.field.value = e;
        }
        // exclude file field (handled by uploadFile)
        if (this.field.display_type != FileField.control_type) {
            let content = {
                field: this.field,
            }
            this.valueChange.emit(content);  // emit valueChange event to update the parent that use this field
        }
    }

    get isValid() {
        if (this.form) {
            return this.form.controls[this.field.key].valid;
        }
    }

    get isVisible() {
        return this.field.visible;
    }

    selectedUser: string;
    openUserLookup() {
        var ref: NgbModalRef = this.openUserLookupEvent();
        ref.result.then((result) => {
            console.log(result);
            this.form.controls[this.field.key].setValue(result.selectedItem.ID);
            this.selectedUser = result.selectedItem.first_name + " " + result.selectedItem.last_name;
        }, (reason) => {
            console.log(reason);
        });
    }

    customInputValue: string;
    openCustomInput() {
        var formFields = this.getCurrentFormValuesEvent();
        var ref: NgbModalRef = this.openCustomInputEvent(formFields, this.field);
        ref.result.then((input) => {
            console.log(input);
            this.form.controls[this.field.key].setValue(input.value);
            this.customInputValue = input.value;
        }, (reason) => {
            console.log(reason);
        });
    }

    uploadFile(event) {
        this.isFileUploading = true;
        let file = event.target.files[0];
        let formData = new FormData();
        formData.append("filename", file.name);
        formData.append("file", file);
        this.apiService.postFile("/models/file/upload", formData).subscribe(
            result => {
                this.isFileUploading = false;
                //console.log(result);
                this.form.controls[this.field.key].setValue(result.storage_key);
                let content = {
                    field: this.field,
                    value: result.storage_key,
                    file: result
                }
                this.valueChange.emit(content);  // emit valueChange event to update the parent that use this field
            }
        );
    }

    isFieldValid(field: string) {
        var bvalid = !this.form.get(field).valid && this.form.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
            'has-feedback': this.isFieldValid(field)
        };
    }

    allowUserLookup(): boolean {
        return this.adminService.allowUserLookup();
    }

    isInputField(field) {
        switch (field.display_type) {
            case HeaderField.control_type:
            case SeparatorField.control_type:
            case Separator1Field.control_type:
                return false;
        }
        return true;
    }

    isHeader(field) { return field.display_type == HeaderField.control_type; }
    isSeparator(field) { return field.display_type == SeparatorField.control_type; }
    isSeparator1(field) { return field.display_type == Separator1Field.control_type; }
    isItemChecked(field, listItem) {
        if (field.value) {
            //console.log(field);
            return field.value && field.value.indexOf && field.value.indexOf(listItem.value) >= 0;
        }
        return false;
    };

    getLabel() {
        var label =  this.field.label;
        if (this.field.label != ' ') label = label + this.subfix_colon;       // append subfix_colon to label if not empty 
        var formulated_label = this.getFormulatedLabelResult(this.field.label);
        if (formulated_label && formulated_label != label) label = formulated_label;
        return label;
    }

    public onFormDataChanged(view_item_data:any):any {
        if (this.formulas) this.current_formula_results = this.formulaService.calculateFormulaValuesByItem(this.formulas, view_item_data);
    }

    public getFormulatedLabelResult(formula_identifier):any {
        var result = null;
        if (this.current_formula_results && formula_identifier && formula_identifier.indexOf('#{') >= 0) {
            var formula_name = formula_identifier.substring(0, formula_identifier.length - 1).replace('#{', '');
            var formula_result = this.current_formula_results.find(f => f.name == formula_name);
            if (formula_result) result = formula_result.result;
        }
        return result;
    }

    public getMSLClass() {
        return "msl-value";
    }

    public getMSLValue() {
        return this.field.value.join('; ');
    }

    onMSLChange(e) {
        console.log(e);
    }

    onMSLClick(e, listItem) {
        if (this.field.display_type == MultiSelectListField.control_type) {
            if (this.field.value == undefined || this.field.value == null) this.field.value = [];
            var index = this.field.value.indexOf(listItem.value);
            if (index >= 0) {
                this.field.value.splice(index, 1);
            } else {
                this.field.value.push(listItem.value);
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/field/field.component.ts